import { EventShow, EventArtist } from "../../interfaces"

export const checkHighestRated = (item: EventArtist | EventShow) => {
  if (window.location.search.includes('myrating')) {
    return item.artist.myrating.score >= 4
  }
  return true
}